import { useEffect, useState } from "react";
import { apiFetch, getToken } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const KEY = "readoo_meteo_city";
const EVT = "readoo-meteo-city";
let pushedToProfile = false;
const DEFAULT_CITY = { name: "Roma", lat: 41.9028, lon: 12.4964 };

export const getWeather = (lat, lon) => apiFetch(`/meteo?lat=${lat}&lon=${lon}`, { auth: false });
export const searchCity = (q) => apiFetch(`/meteo/cerca?q=${encodeURIComponent(q)}`, { auth: false });

function storeLocal(city, at = new Date().toISOString()) {
  localStorage.setItem(KEY, JSON.stringify({ name: city.name, lat: city.lat, lon: city.lon, manual: true, at }));
  window.dispatchEvent(new Event(EVT));
}

// Salva sul dispositivo e, se il lettore ha fatto l'accesso, anche nel profilo (vale su tutti i dispositivi).
export function saveCity(city) {
  storeLocal(city);
  if (getToken()) apiFetch(`/me/meteo-city`, { method: "PUT", body: { name: city.name, lat: city.lat, lon: city.lon } }).catch(() => {});
}

function readCity() {
  try {
    const c = JSON.parse(localStorage.getItem(KEY) || "null");
    return c?.manual ? c : DEFAULT_CITY;
  } catch { return DEFAULT_CITY; }
}

// Città del profilo (se c'è l'accesso), altrimenti quella del dispositivo, altrimenti Roma; meteo aggiornato ogni 30 minuti.
export function useWeather() {
  const { user } = useAuth();
  const [city, setCity] = useState(readCity);
  const [data, setData] = useState(null);

  useEffect(() => {
    const onChange = () => setCity(readCity());
    window.addEventListener(EVT, onChange);
    return () => window.removeEventListener(EVT, onChange);
  }, []);

  const saved = user?.meteo_city;
  const loggedIn = !!user;
  useEffect(() => {
    const local = readCity();
    if (!saved) {
      // città scelta prima dell'accesso: la porto nel profilo
      if (loggedIn && local.manual && !pushedToProfile) {
        pushedToProfile = true;
        apiFetch(`/me/meteo-city`, { method: "PUT", body: { name: local.name, lat: local.lat, lon: local.lon } }).catch(() => {});
      }
      return;
    }
    // il profilo vince solo se più recente della scelta fatta su questo dispositivo
    if ((saved.at || "") > (local.at || "") && (local.name !== saved.name || local.lat !== saved.lat)) storeLocal(saved, saved.at);
  }, [saved, loggedIn]);

  const { lat, lon } = city;
  useEffect(() => {
    let alive = true;
    const tick = () => getWeather(lat, lon).then((d) => alive && setData(d)).catch(() => {});
    tick();
    const iv = setInterval(tick, 30 * 60 * 1000);
    return () => { alive = false; clearInterval(iv); };
  }, [lat, lon]);

  return { city, data };
}
